<div class="container" [ngSwitch]="showList">
    <div class="d-flex align-items-center mb-4">
        <h1 class="mb-0 me-3"><i class="far fa-building text-primary"></i> Manage Vendors</h1>
        <a href="javascript:void(0)" class="btn btn-round btn-primary text-uppercase text-strong hvr-grow"
            (click)="viewVendor(null)"><i class="far fa-plus"></i> New</a>
    </div>
    <div class="card round-corners heavy-shadow p-3 mb-3">
        <div class="row align-items-end gx-2">
            <div class="col-xxl-2 col-xl-6 mb-3 mb-xxl-0">
                <label class="form-label">Vendor's Name</label>
                <input type="text" class="form-control form-control-lg" placeholder="Vendor's Name"
                    (keydown)="inputFieldChange($event)" (ngModelChange)="hideTheList()"
                    [(ngModel)]="filter.nameFilter" />
            </div>
            <div class="col-xxl-3 col-xl-6 mb-3 mb-xxl-0 mobiscroll-select">
                <label class="form-label d-block">Top Level Account</label>
                <input mbsc-select id="filter-account-input" class="mobi-input form-control form-control-lg"
                    [(ngModel)]="filter.accountId" placeholder="Select Top Level Account" [data]="accounts"
                    [mbscOptions]="selectOptions" />
            </div>
            <div class="col-xxl-2 col-xl-6 mb-3 mb-xxl-0">
                <label class="form-label">Status</label>
                <div class="dropdown w-100" ngbDropdown>
                    <button class="btn btn-white btn-lg w-100" ngbDropdownToggle type="button" id="dropdownMenuButton1"
                        aria-expanded="false">
                        <span>{{filter.vendorStatus.text}}</span>
                    </button>
                    <ul class="w-100" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                        <ng-container *ngFor="let f of statusFilters">
                            <li *ngIf="filter.vendorStatus.value !== f.value"><a ngbDropdownItem class="dropdown-item"
                                    href="javascript:void(0)" (click)="selectStatusFilter(f)">{{f.text}}</a></li>
                        </ng-container>
                    </ul>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-6 mb-3 mb-xxl-0">
                <label class="form-label">PO Transmission Method</label>
                <div class="dropdown w-100" ngbDropdown>
                    <button class="btn btn-white btn-lg w-100" ngbDropdownToggle type="button" id="dropdownMenuButton1"
                        aria-expanded="false">
                        <span>{{filter.poTransmissionType.text}}</span>
                    </button>
                    <ul class="w-100" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                        <ng-container *ngFor="let f of poTransmissionTypes">
                            <li *ngIf="filter.poTransmissionType.value !== f.value"><a ngbDropdownItem
                                    class="dropdown-item" href="javascript:void(0)"
                                    (click)="selectTransmissionType(f)">{{f.text}}</a></li>
                        </ng-container>
                    </ul>
                </div>
            </div>
            <div class="col-xl mb-3 mb-xl-0">
                <div class="row gx-2 justify-content-xxl-end justify-content-center search-btns">
                    <div class="col-auto">
                        <button type="button" class="btn btn-secondary btn-round btn-lg text-uppercase text-strong"
                            (click)="showTheList()"><i class="far fa-search"></i> Search</button>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-white btn-round btn-lg text-uppercase text-strong"
                            (click)="resetFilters()"><i class="far fa-times"></i> Clear</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card round-corners heavy-shadow p-3 text-center" *ngSwitchCase="false">
        <h3>Search Vendors</h3>
        <p>Enter search parameters above to find vendors.</p>
        <div class="mx-auto">
            <button type="button" class="btn btn-round btn-outline-secondary text-uppercase text-strong"
                (click)="showTheList()">Show All</button>
        </div>
    </div>
    <div class="card round-corners heavy-shadow p-3 text-center" *ngSwitchCase="true">
        <div
            class="d-flex flex-column flex-md-row justify-content-md-between justify-content-center align-items-center mb-3">
            <h4 class="mb-md-0">{{filter.showing(results.recordsFiltered)}}</h4>
            <button type="button" class="btn btn-round btn-white text-strong" *ngIf="results.recordsFiltered > 0"
                (click)="exportVendors()"><i class="far fa-file-export"></i> Export {{results.recordsFiltered}}
                Vendors</button>
        </div>
        <div class="card no-shadow rounded border">
            <table class="table table-striped table-hover align-middle m-0">
                <thead>
                    <tr>
                        <th>
                            <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Name"
                                [cb]="loadList"></table-sorting>
                        </th>
                        <th>PO Transmission Method</th>
                        <th>PO Transmission File Type</th>
                        <th>Import Notifications</th>
                        <th class="text-right"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="results.data.length == 0">
                        <td colspan="5" class="text-center">No Results</td>
                    </tr>
                    <tr *ngFor="let vendor of results.data"
                        [ngClass]="{'table-danger': vendor.masterImportError || vendor.formularyImportError}">
                        <td>{{vendor.vendorName}}</td>
                        <td *ngIf="vendor.poTransmissionMethod == pdxTransmissionMethod.EFax"><i
                                class="far fa-fax text-muted"></i> {{vendor.poTransmissionMethodDisplay}}:
                            {{vendor.poTransmissionDetail}}</td>
                        <td *ngIf="vendor.poTransmissionMethod == pdxTransmissionMethod.Email"><i
                                class="far fa-envelope text-muted"></i> {{vendor.poTransmissionMethodDisplay}}:
                            {{vendor.poTransmissionDetail}}</td>
                        <td *ngIf="vendor.poTransmissionMethod == pdxTransmissionMethod.SFTP"><i
                                class="far fa-server text-muted"></i> {{vendor.poTransmissionMethodDisplay}}:
                            {{vendor.poTransmissionDetail}}</td>
                        <td>{{vendor.poFileType}}</td>
                        <td>
                            <ul class="list-unstyled d-flex m-0">
                                <li class="me-1" *ngIf="vendor.masterImportError">
                                    <h5 class="m-0"><span
                                            class="badge rounded-pill bg-danger d-flex align-items-center py-1"><span
                                                class="circle-icon bg-master me-1">M</span> Import Error</span></h5>
                                </li>
                                <li class="me-1" *ngIf="vendor.formularyImportError">
                                    <h5 class="m-0"><span
                                            class="badge rounded-pill bg-danger d-flex align-items-center py-1"><span
                                                class="circle-icon bg-formulary me-1">F</span> Import Error</span></h5>
                                </li>
                                <li class="me-1" *ngIf="vendor.masterImportProcessing">
                                    <h5 class="m-0"><span
                                            class="badge rounded-pill bg-warning-light d-flex align-items-center py-1"><span
                                                class="circle-icon bg-master me-1">M</span> Import Processing</span>
                                    </h5>
                                </li>
                                <li class="me-1" *ngIf="vendor.formularyImportProcessing">
                                    <h5 class="m-0"><span
                                            class="badge rounded-pill bg-warning-light d-flex align-items-center py-1"><span
                                                class="circle-icon bg-formulary me-1">F</span> Import Processing</span>
                                    </h5>
                                </li>
                            </ul>
                        </td>
                        <td class="text-right">
                            <a href="javascript:void(0)" class="btn btn-lg btn-white btn-shadow action-btn"
                                (click)="viewVendor(vendor.vendorId)"><i class="far fa-arrow-right"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            class="p-3 d-md-flex align-items-center justify-content-md-between justify-content-center text-center text-md-left">
            <p class="m-md-0 mb-3">{{filter.showing(results.recordsFiltered)}}</p>
            <ngb-pagination [(page)]="filter.page" [pageSize]="filter.pageSize"
                [collectionSize]="results.recordsFiltered" (pageChange)="loadList(false)" size="lg" [maxSize]="5"
                [rotate]="true" [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>
        </div>
        <form novalidate #exportForm ngNoForm name="exportForm" method="post" action="/Vendors">
            <input type="hidden" name="nameFilter" [(ngModel)]="filter.nameFilter" />
            <input type="hidden" name="accountId" [(ngModel)]="filter.accountId" />
            <input type="hidden" name="vendorStatus.value" [(ngModel)]="filter.vendorStatus.value" />
            <input type="hidden" name="poTransmissionType.value" [(ngModel)]="filter.poTransmissionType.value" />
        </form>
    </div>
</div>